import {
  PAYMENT_METHOD_MAPPING,
  PAYMENT_TIMING_MAPPING,
  ORDER_METHOD_MAPPING,
  GET_PAYMENT_METHOD_MAPPING,
  GET_PAYMENT_TIMING_MAPPING,
  GET_ORDER_METHOD_MAPPING,
} from './constants';

export default {
  [GET_PAYMENT_METHOD_MAPPING]() {
    return PAYMENT_METHOD_MAPPING;
  },
  [GET_PAYMENT_TIMING_MAPPING]() {
    return PAYMENT_TIMING_MAPPING;
  },
  [GET_ORDER_METHOD_MAPPING]() {
    return ORDER_METHOD_MAPPING;
  },
};
